import React from 'react';
import Text from '../typography';
import { StepBoxSC } from './step-box.styled';

interface StepBoxItem {
  title: React.ReactNode;
  description?: React.ReactNode;
}

interface StepBoxProps {
  items: StepBoxItem[];
  style?: React.CSSProperties;
  className?: string;
  variant?: 'simple' | 'line';
}

const StepBox: React.FunctionComponent<StepBoxProps> = ({
  items,
  style,
  className,
  variant = 'line',
}) => {
  return (
    <StepBoxSC style={style} className={className} showLine={variant === 'line'}>
      {items.map((i, idx) => (
        <li key={idx}>
          <Text display="h6" variant="default" className="step-box-title" as="p">
            {i.title}
          </Text>
          {i.description ? (
            <Text display="body2" variant="default" className="step-box-description" as="span">
              {i.description}
            </Text>
          ) : null}
        </li>
      ))}
    </StepBoxSC>
  );
};

export default React.memo(StepBox);
